import React from 'react';
import { Testimonial } from './Testimonial';
export function CortisolReveal() {
  return <section className="py-12 md:py-24 px-4 bg-brand-cream/50 relative" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-brand-gold/20 mb-10 md:mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-4">
            The "Cortisol" Revelation
          </h2>

          <div className="space-y-6 text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-5">
            <p data-id="element-6">
              Most fitness "gurus" tell you to grind harder. They want you to do
              60-minute HIIT workouts and count every leaf of kale.
            </p>
            <p className="font-bold text-brand-charcoal" data-id="element-7">
              But for a postpartum mom, that is metabolic suicide.
            </p>
            <p data-id="element-8">
              When you're sleep-deprived, "grinding" spikes your Cortisol. And
              high Cortisol tells your body to store fat around your belly to
              protect your milk supply.
            </p>
            <div className="bg-brand-sage/10 p-6 rounded-xl border-l-4 border-brand-sage mt-8" data-id="element-9">
              <p className="text-xl font-bold text-brand-sage font-heading" data-id="element-10">
                You don't need more exercise. You need a Hormonal Reset.
              </p>
            </div>
          </div>
        </div>

        <Testimonial imageSrc="https://cdn.magicpatterns.com/uploads/66unvgRtNtjoqRv4YQAhbk/hf_20260306_151443_997722b1-0fec-48dd-86bd-ca7e9ef221e5.png" quote="I was terrified of the C-section shelf forever. I tried other programs, but they were too intense and actually hurt my scar. The Snap-Back Blueprint was the first thing that felt safe. In 3 weeks, the numbness is gone and I actually have energy to play with my kids. I feel like ME again!" author="Jessica M., Austin, TX" result="C-Section bulge flattened." imagePosition="right" data-id="element-11" />
      </div>
    </section>;
}